import routes from './routes';

export default routes;
export * from './Pages/index';
export * from './Components/index';
